import { useTheme } from 'foundations-theming-specialty/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const InfoIcon = () => {
  const theme = useTheme();
  return /*#__PURE__*/_jsx("svg", {
    fill: theme.color['icon-core-subtle'],
    width: "13px",
    height: "13px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 .7C8.7.7 2.8 6.6 2.8 13.9S8.7 27.1 16 27.1s13.2-5.9 13.2-13.2S23.3.7 16 .7zm0 4c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4.4 16.5c0 .2-.1.3-.3.3H13c-.2 0-.3-.1-.3-.3v-1.4c0-.2.1-.3.3-.3h2c.2 0 .3-.1.3-.3v-7c0-.2-.1-.3-.3-.3h-1.4c-.2 0-.3-.1-.3-.3v-1c0-.2.1-.3.3-.3h3.9c.2 0 .3.1.3.3v8.6c0 .2.1.3.3.3h2c.2 0 .3.1.3.3v1.4z"
    })
  });
};
export default InfoIcon;